import _ from "underscore";

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import PlayButton from './PlayButton';
import ProgressBar from './ProgressBar';
import VolumeControl from './VolumeControl';
import DownloadButton from './DownloadButton';
import CloseButton from './CloseButton';

class BrowserAudioPlayer extends Component {
  constructor() {
    super();
    this.state = {
      hidden: true,
      mute: false,
      volumeLevel: 1
    };
    _.bindAll(this,
      'handleTogglePlay',
      'handleToggleMute',
      'handleTimeUpdate',
      'handleShiftAudioProgress',
      'handleShiftVolumeLevel',
      'handleEndPlay',
      'handleAudioError',
      'handleCloseAudioBrowser',
      'setAudioSrc',
      'setAudioPlay',
      'setAudioTime'
    );
  }

  componentDidMount() {
    this.audio = new Audio();
    this.audio.addEventListener('timeupdate', this.handleTimeUpdate);
    this.audio.addEventListener('ended', this.handleEndPlay);
    this.audio.addEventListener('error', this.handleAudioError);
    this.props.collection.on('change', this.forceUpdate.bind(this, null), this);
    this.props.collection.on('change:play', this.setAudioPlay);
    this.props.collection.on('newAudioSrc', this.setAudioSrc);
    this.props.collection.on('newAudioTime', this.setAudioTime);
  }

  componentWillUnmount() {
    this.audio.removeEventListener('timeupdate', this.handleAudioProgressUpdate);
    this.audio.removeEventListener('ended', this.handleEndPlay);
    this.audio.removeEventListener('error', this.handleAudioError);
  }

  componentWillUpdate(nextProps, nextState) {
    this.setAudioVolume(nextState.volumeLevel, nextState.mute);
  }

  handleTogglePlay() {
    this.recording().togglePlay();
  }

  handleToggleMute() {
    this.setState({ mute: !this.state.mute });
  }

  handleTimeUpdate() {
    this.recording().shiftBrowserAudioProgress(this._currentAudioProgress());
  }

  handleShiftAudioProgress(audioProgress) {
    this.audio.currentTime = this._currentAudioTime(audioProgress);
  }

  handleShiftVolumeLevel(volumeLevel) {
    this.setState({
      volumeLevel: volumeLevel,
      mute: false
    });
  }

  handleEndPlay() {
    this.recording().deactivate();
  }

  handleAudioError(evt) {
    const error = evt && evt.target && evt.target.error;
    if (error) {
      this.recording().setAlert("Audio playback error, please reload the page and try again.");
    }
  }

  handleCloseAudioBrowser() {
    this.props.collection.deactivate();
    this.setState({
      hidden: true,
      mute: false
    });
  }

  setAudioPlay() {
    this.recording().get('play') ? this.audio.play() : this.audio.pause();
  }

  setAudioVolume(volumeLevel, mute) {
    if (this.state.volumeLevel !== volumeLevel || this.state.mute !== mute) {
      this.audio.volume = mute ? 0 : volumeLevel;
    }
  }

  setAudioTime() {
    if (parseFloat(this.audio.currentTime.toFixed(3)) !== parseFloat(this._currentAudioTime(this.recording().get('audioProgress')).toFixed(3))) {
      this.audio.currentTime = this._currentAudioTime(this.recording().get('audioProgress'));
    }
  }

  setAudioSrc() {
    this.audio.src = this.recording().get('recordingUrl');
    this.setState({ hidden: false });
    let handleCanPlay = function() {
      this._startAudio();
      this.audio.removeEventListener('canplay', handleCanPlay);
    }.bind(this);
    this.audio.addEventListener('canplay', handleCanPlay);
  }

  recording() {
    return this.props.collection.activeRecording;
  }

  _startAudio() {
    this.setAudioTime();
    this.recording().play();
    this.recording().setTrueRecordingDuration(this.audio.duration);
  }

  _currentAudioProgress() {
    return this.audio.currentTime / this.audio.duration;
  }

  _currentAudioTime(audioProgress) {
    return (isNaN(this.audio.duration) || isNaN(audioProgress)) ? 0 : (this.audio.duration * audioProgress);
  }

  _transitionClass() {
    return this.state.hidden ? 'browser-audio-player-hidden' : 'browser-audio-player-slideup';
  }

  render() {
    return (
      <div className={classNames("browser-audio-player", this._transitionClass())}>
        <PlayButton play={this.recording().get('play')} togglePlay={this.handleTogglePlay}/>
        <ProgressBar audioProgress={this.recording().get('audioProgress')} audioTime={this.recording().audioTime()} shiftAudioProgress={this.handleShiftAudioProgress}/>
        <VolumeControl volumeLevel={this.state.volumeLevel} mute={this.state.mute} toggleMute={this.handleToggleMute} shiftVolumeLevel={this.handleShiftVolumeLevel}/>
        <DownloadButton recordTitle={this.recording().get('recordTitle')} recordId={this.recording().get('recordId')} recordingUrl={this.recording().get('downloadUrl')}/>
        <CloseButton closeAudioBrowser={this.handleCloseAudioBrowser}/>
      </div>
    );
  }
}

BrowserAudioPlayer.propTypes = {
  collection: PropTypes.object.isRequired
};

export default BrowserAudioPlayer;
